import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import { GET_ATD_LECTURER_BY_ATDID, UPDATE_STD_ATD_BY_LEC } from '../../../APIS';
import { Error404, SkeletonLoad } from '../../../../../Library/LoaderPage';
import { AlertNotif } from '../../../../../Library/AlertNotif';
import moment from 'moment';
import { openModal, PopUpMessage } from '../../../../../Library/ModalPopUp';
import { ConfirmAtd, OpenLocation } from './CompUI';
import { EncodeURIComponentSafe, StudentIDFormat } from '../../../../../Library/GlobalHelper';
import { openToast } from '../../../../../Library/ToastPopUp';

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];


export function FormAtdStudents({ data, Reload }) {
    const [results, setResult] = useState({ loading: false, data: [], message: "" });
    const [students, setStudents] = useState([]);
    const ReloadData = async () => {
        setResult({ loading: true, data: [], message: "" })
        const param = { atdid: data.id }
        const result = await GET_ATD_LECTURER_BY_ATDID(param);
        if (result.data && Object.values(result.data).length > 0) {
            if (result.data.atd_student && Object.values(result.data.atd_student).length > 0) {
                const data_students = result.data.atd_student.map((v) => {
                    if (v.studentstatusdata && v.studentstatusdata.fullname) {
                        v.studentstatusdata.fullname = v.studentstatusdata.fullname
                            .split(' ')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ');
                    }
                    return v;
                })
                data_students.sort((a, b) => {
                    const nameA = a.studentstatusdata?.fullname?.toUpperCase() || '';
                    const nameB = b.studentstatusdata?.fullname?.toUpperCase() || '';
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });

                const studentLst = data_students.map((v) => {
                    var obj = {};
                    obj.remark = (v.remark) ? v.remark : "";
                    obj.flag_sts = v.flag_sts;
                    obj.status = v.status;
                    obj.atd = v.atd === 0 ? '0%' : v.atd ? `${v.atd}%` : '';
                    obj.studentid = v.studentid;
                    obj.tap_time = v?.tap_time || "";
                    obj.coordinate = v?.coordinate || "";
                    obj.stundentname = (v.studentstatusdata) ? v.studentstatusdata.fullname : "-";
                    return obj;
                })
                setStudents(studentLst);
            } else {
                setStudents([]);
            }
        } else {
            setStudents([]);
        }
        setResult(result);
    }

    useEffect(() => {
        ReloadData();
    }, [data]);

    const updateStudentValue = (studentId, keyname, newStatus) => {
        setStudents(prevStudents => prevStudents.map(student =>
            student.studentid === studentId ? { ...student, [keyname]: newStatus } : student
        ));
    };

    const [submit, setSubmit] = useState({ loading: false, data: [], message: "" });

    const SubmitAtd = async () => {
        if (AuthDecode.remotedBy) {
            openToast({ header: "Error", message: "You cannot access this request" });
            openModal({ open: false });
        } else {
            openModal({ open: false });
            setSubmit({ loading: true, data: [], message: "" });
            const param = {
                atd_lec_id: data.id,
                student: students.map(v => {
                    return { remark: EncodeURIComponentSafe(v.remark), status: v.status, studentid: v.studentid }
                })
            }
            const result = await UPDATE_STD_ATD_BY_LEC(param);
            if (result.data && Object.values(result.data).length > 0) {
                openModal({ message: <PopUpMessage title={"Successfully updated"} type="success" /> });
                Reload();
                window.scrollTo(0, 0);
            } else {
                openModal({ message: <PopUpMessage title={"Failed updated"} message={result.message} type="error" /> })
            }

            setSubmit(result)
        }
    }

    return (
        <div className='border-top py-8 mt-8 px-8'>
            <div className="frm-header d-flex align-items-center justify-content-between mb-5">
                <div className="h-title">
                    <h4>Form Student Attendance</h4>
                    <span className="text-muted">Total {Object.values(students).length} Student</span>
                </div>
                <div className="h-action">
                    <button className="btn btn-light btn-sm d-flex align-items-center" type="button" onClick={() => ReloadData()}>
                        <i className="fa fa-sync icon-sm"></i>
                        Refresh
                    </button>
                </div>
            </div>

            <div className="frm-body">

                <table className="table table-head-custom table-head-bg table-borderless table-vertical-start">
                    <thead>
                        <tr>
                            <th width="5%">No</th>
                            <th width="35%">Student</th>
                            <th width="15%">Attendance</th>
                            <th width="8%">Absent</th>
                            <th width="15%">Remark</th>
                            <th>Tap Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.loading ? <tr><td colSpan={6}><SkeletonLoad /></td></tr> :
                            results.message ? <tr><td colSpan={6}><AlertNotif message={results.message} color="danger" /></td></tr> :
                                results.data && Object.values(results.data).length > 0 && Object.values(students).length > 0 ? (
                                    students.map((v, index) => (
                                        <tr key={index} className={(v.flag_sts === 4 || v.flag_sts === 5) ? "bg-light-danger" : ""}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <span className="font-weight-bold d-block">
                                                    {v.stundentname}
                                                </span>
                                                <span className="text-muted">
                                                    {StudentIDFormat(v.studentid)}
                                                </span>
                                            </td>
                                            <td>
                                                {(v.flag_sts === 1 || v.flag_sts === 4 || v.flag_sts === 5) ? (
                                                    <>
                                                        <label className='mr-3'>
                                                            <input type="radio" name={"atd-" + v.studentid} value={"P"} defaultChecked={(v.status == "P") ? true : false} onChange={() => updateStudentValue(v.studentid, "status", "P")} /> Present
                                                        </label>
                                                        <label>
                                                            <input type="radio" name={"atd-" + v.studentid} value={"A"} defaultChecked={(v.status == "A") ? true : false} onChange={() => updateStudentValue(v.studentid, "status", "A")} /> Absent
                                                        </label>
                                                    </>
                                                ) : (
                                                    <span className="text-danger">{v.remark}</span>
                                                )}
                                            </td>
                                            <td>{v.atd}</td>
                                            <td>
                                                {(v.flag_sts === 1 || v.flag_sts === 4 || v.flag_sts === 5) && (
                                                    <input type="text" name="remarks" className='form-control' defaultValue={v.remark} autoComplete='off' onChange={(e) => updateStudentValue(v.studentid, "remark", e.target.value)} />
                                                )}
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {(v.tap_time) ? (
                                                        <span className='font-size-sm'>{moment(v.tap_time).format('D MMM YYYY hh:mm a')}</span>
                                                    ) : <span className="font-size-sm">-</span>}
                                                    <OpenLocation data={v} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : <tr><td colSpan={6}><Error404 /></td></tr>}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={6} className='text-center'>
                                <button className="btn btn-lg btn-primary text-uppercase px-15 font-weight-bold" type='button' onClick={() => openModal({ header: "Confirmation", message: <ConfirmAtd submit={SubmitAtd} /> })} disabled={submit.loading}>
                                    <div className=" d-flex align-items-center">
                                        {submit.loading ? (
                                            <>
                                                <i className="fas fa-save icon-lg spinner"></i>
                                                <span>Processing..</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-save icon-lg"></i>
                                                <span>Submit</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

